import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full m-auto" }
const _hoisted_2 = { class: "w-full flex border-b border-b-1 border-b-Border/border_natural mt-[4px]" }
const _hoisted_3 = { class: "w-full flex" }

import dashboardFilterBar from '@/views/dashboard/components/dashboard-filter-bar/dashboard-filter-bar.vue';
import dashboardTabs from '@/views/dashboard/components/dashboard-tabs.vue';
import { useRoute } from 'vue-router';
import LayoutHeader from '../../Layout/layout-header/layout-header.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-header',
  setup(__props) {

const route = useRoute();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutHeader, {
    title: (_unref(route).meta.title as string),
    style: {"background":"#fff","z-index":"99","position":"sticky","top":"0","box-shadow":"0px 4px 5px 0px #00000024"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(dashboardTabs, { style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column"} })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(dashboardFilterBar, { style: {"width":"100%","display":"inline-flex","flex-direction":"column"} })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})